import axios from 'axios'
import { callApi } from '@/utils/api'
import type { UserInfo } from '@/types/user'
import type { ApiMessageIds, ApiMessage } from '@/types/apiResponse'

export type { UserInfo } from '@/types/user'

const BASE_URL = import.meta.env.VITE_BASE_URL as string

/**
 * /login を呼び出す
 */
interface LoginParams {
  loginName: string
  password: string
}

export async function login(values: LoginParams): Promise<ApiMessageIds | ApiMessage> {
  // CSRF Cookie 取得
  await axios.get(`${BASE_URL}/sanctum/csrf-cookie`)

  return await callApi<ApiMessageIds | ApiMessage, { login_name: string; password: string }>(
    '/login',
    'POST',
    { login_name: values.loginName, password: values.password },
    BASE_URL,
  )
}

/**
 * /user_info を呼び出す
 */
export async function fetchUserInfo(): Promise<UserInfo> {
  return await callApi<UserInfo>('/user-info', 'GET')
}

/**
 * /logout を呼び出す
 */
export async function logout(): Promise<ApiMessage> {
  return await callApi<ApiMessage, undefined>('/logout', 'POST')
}
